import * as React from 'react';
import { IFilterableListFacet, IFilterableListFacetTerm } from '../../global/dtos/filterable-list-results-dto';
import { DropdownFacet } from '../../global/components/inputs/filters/dropdown-facet';

interface IProps {
    facets: IFilterableListFacet[];
    onUpdateFacet: (facets: IFilterableListFacet[]) => void;

    filterHeaderText: string
    facetsResetLinkText: string;
    isMobile: boolean;
}

interface IState {
    mobileFacetsVisible: boolean;
}


export class FilterableListFacets extends React.Component<IProps, IState> {

    constructor(props) {
        super(props);

        this.state = {
            mobileFacetsVisible: false,
        }
    }

    render() {
        const className = this.state.mobileFacetsVisible ? 'active' : '';

        return (
            <div className={"sidebar filterable-list-filters " + className} >
                {this.renderHeader()}
                <div className="facets">
                    {this.props.facets.map((facet, index) => (this.renderFacet(facet, index)))}
                </div>
            </div >
        )
    }

    renderHeader = () => (
        <div className="search-facet-header">
            {this.props.isMobile && this.renderMobileToggle()}
            <h4 className="search-facet-header-title">{this.props.filterHeaderText}</h4>
            <div className="search-facet-header-clear" onClick={this.onResetFacets}>
                <u>Reset</u>
            </div>
        </div>
    )

    renderMobileToggle = () => (
        <div className="search-facet-header-mobile" onClick={this.onToggleMobileFacets}>
            <svg className="open">
                <use xlinkHref="#icon-refine"></use>
            </svg>
            <svg className="close">
                <use xlinkHref="#icon-close"></use>
            </svg>
        </div>
    )

    onToggleMobileFacets = () => {
        this.setState({ mobileFacetsVisible: !this.state.mobileFacetsVisible })
    }

    renderFacet = (value: IFilterableListFacet, index) => {
        return <DropdownFacet
            facets={this.props.facets}
            facet={value}
            index={index}
            onUpdateSearchFacet={this.props.onUpdateFacet}
            key={value.name}
        />
    }

    onResetFacets = () => {
        const { facets, onUpdateFacet } = this.props;

        const newFacets = facets.map(f => ({
            ...f,
            terms: f.terms.map(t => ({
                ...t,
                selected: false
            }))
        }));

        onUpdateFacet(newFacets);
    }
}

